import { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function LibraryParametres() {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ loanDurationDays: 14, maxLoansPerStudent: 3, overdueFeeDailyXof: 100 });
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/library/settings').then((s) => {
      if (s) {
        setSettings(s);
        setForm({
          loanDurationDays: s.loanDurationDays || s.loan_duration_days || 14,
          maxLoansPerStudent: s.maxLoansPerStudent || s.max_loans_per_student || 3,
          overdueFeeDailyXof: s.overdueFeeDailyXof || s.overdue_fee_daily_xof || 100,
        });
      }
    }).catch((e) => setError(e.message));
  }, []);

  async function save() {
    setError(''); setSaved(false);
    try {
      await api.post('/library/settings', form);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (e) { setError(e.message); }
  }

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: Number(e.target.value) }));

  return (
    <div className="panel">
      <div className="panel-head"><h2>Paramètres de la bibliothèque</h2></div>
      <div className="panel-body" style={{ maxWidth: 480 }}>
        {error && <div className="form-error">{error}</div>}
        {saved && <div className="receipt-banner">Paramètres enregistrés ✓</div>}

        <div className="fieldset-title">Emprunts</div>
        <div className="field">
          <label>Durée standard d'emprunt (jours)</label>
          <input type="number" min="1" max="90" value={form.loanDurationDays} onChange={set('loanDurationDays')} />
          <small style={{ color: 'var(--muted)' }}>Nombre de jours accordés par défaut pour chaque emprunt.</small>
        </div>
        <div className="field">
          <label>Nombre maximum d'ouvrages par emprunteur</label>
          <input type="number" min="1" max="20" value={form.maxLoansPerStudent} onChange={set('maxLoansPerStudent')} />
          <small style={{ color: 'var(--muted)' }}>Limite simultanée d'emprunts actifs par élève.</small>
        </div>

        <div className="fieldset-title">Pénalités</div>
        <div className="field">
          <label>Barème pénalité par jour de retard (XOF)</label>
          <input type="number" min="0" step="50" value={form.overdueFeeDailyXof} onChange={set('overdueFeeDailyXof')} />
          <small style={{ color: 'var(--muted)' }}>Montant appliqué chaque jour après la date de retour prévue.</small>
        </div>

        <div style={{ marginTop: 20 }}>
          <button className="btn" onClick={save} style={{ width: 'auto', padding: '0 24px' }}>Enregistrer les paramètres</button>
        </div>
      </div>
    </div>
  );
}
